/**
 * Class representing airport data
 */
export class Airport {
  /**
   * Create airport data.
   * @param {object} options - the airport options to construct the airport object
   * @param {String} name - name of the airport
   * @param {Number} id - id of the airport
   * @param {String} code - code of the airport
   */
  constructor (options) {
    this.name = options.name
    this.id = options.id
    this.code = options.code
  }

  get code () {
    return this._code
  }

  set code (value) {
    if (value) this._code = String(value)
    else this._code = null
  }

  get id () {
    return this._id
  }

  set id (value) {
    if (value) this._id = Number(value)
    else this._id = null
  }

  get name () {
    return this._name
  }

  set name (value) {
    if (value) this._name = String(value)
    else this._name = null
  }

  toJSON () {
    return {
      code: this._code,
      id: this._id,
      name: this._name
    }
  }
}
